<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left"  id="my-modal-title">{{ title | globalTranslate}}</h1>
    <button type="button" class="btn-close pull-right" aria-label="Close" (click)="onCancel()">
      <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon"/>
    </button>
  </div>
  <div class="modal-body">
    <h2>
      <strong>{{ 'ANALYTICS_POLICY_TITLE' | globalTranslate }}</strong>
    </h2>
    <p>
      {{ 'ANALYTICS_POLICY_PARAGRAPH_1_PART_1' | globalTranslate }}
      <a class="text-uppercase" target="_blank" href="https://www.google.com/analytics/terms/us.html"
        [title]="'ANALYTICS_TERMS_OF_USE' | globalTranslate"><b>{{ 'ANALYTICS_TERMS_OF_USE' | globalTranslate }}</b></a>
      {{ 'AND_THE' | globalTranslate }}
      <a class="text-uppercase" target="_blank" href="https://policies.google.com/privacy" [title]="'GOOGLE_PRIVACY_POLICY' | globalTranslate"><b>{{
        'GOOGLE_PRIVACY_POLICY' | globalTranslate }}</b></a>.
    </p>
    <p>
      {{ 'ANALYTICS_POLICY_PARAGRAPH_2_PART_1' | globalTranslate }}
      <a class="text-uppercase" target="_blank" href="https://tools.google.com/dlpage/gaoptout" [title]="'ANALYTICS_OPT_OUT_ADDON' | globalTranslate">
        <b>{{ 'ANALYTICS_OPT_OUT_ADDON' | globalTranslate }}</b>
      </a>.
    </p>
  </div>
</div>